export default __webpack_public_path__ + "static/media/addNow.90a7e4ed.svg";